import { useEffect, useRef } from 'react';
import { DraftSelectionInteraction, TimelineScale } from './types';

export const usePlannerRefs = (draftInteraction: DraftSelectionInteraction | null) => {
    const timelineRef = useRef<HTMLDivElement>(null);
    const timelineScrollLockRef = useRef(false);
    const isProgrammaticTimelineNavigationRef = useRef(false);
    const pendingPrependHeightRef = useRef<number | null>(null);
    const pendingPrependAnchorRef = useRef<{ key: string; top: number } | null>(null);
    const pendingTimelineCurrentScrollRef = useRef(false);
    const pendingTimelineCurrentSmoothScrollRef = useRef(false);
    const pendingTimelineTaskScrollRef = useRef<Date | null>(null);
    const pendingTimelineTaskIdScrollRef = useRef<string | null>(null);
    const pendingTimelineTaskScrollAttemptsRef = useRef(0);
    const pendingTimelineDaysViewDateRef = useRef<Date | null>(null);
    const pendingTimelineZoomTargetRef = useRef<{ date: Date; scale: TimelineScale } | null>(null);
    const suppressNextTimelineCurrentScrollRef = useRef(false);
    const dragAutoScrollFrameRef = useRef<number | null>(null);
    const dragAutoScrollPointerYRef = useRef<number | null>(null);
    const dragAutoScrollActiveRef = useRef(false);
    const draftInteractionRef = useRef<DraftSelectionInteraction | null>(null);
    const pendingCreateListenersRef = useRef<{
        pointerMove: (event: PointerEvent) => void;
        pointerUp: (event: PointerEvent) => void;
        pointerCancel: (event: PointerEvent) => void;
    } | null>(null);
    const pendingTouchCreateRef = useRef<{
        date: Date;
        hour: number;
        pointerId: number;
        pointerType: string;
        startY: number;
        target: HTMLElement;
    } | null>(null);
    useEffect(() => {
        draftInteractionRef.current = draftInteraction;
    }, [draftInteraction]);
    return {
        timelineRef, timelineScrollLockRef, isProgrammaticTimelineNavigationRef,
        pendingPrependHeightRef, pendingPrependAnchorRef, pendingTimelineCurrentScrollRef,
        pendingTimelineCurrentSmoothScrollRef, pendingTimelineTaskScrollRef,
        pendingTimelineTaskIdScrollRef, pendingTimelineTaskScrollAttemptsRef,
        pendingTimelineDaysViewDateRef, pendingTimelineZoomTargetRef,
        suppressNextTimelineCurrentScrollRef, dragAutoScrollFrameRef,
        dragAutoScrollPointerYRef, dragAutoScrollActiveRef, draftInteractionRef,
        pendingCreateListenersRef, pendingTouchCreateRef,
    };
};

export type PlannerRefs = ReturnType<typeof usePlannerRefs>;
